import './app.scss';
import domready from 'domready';
import 'lazysizes';
import { loadGoogleApi } from './utilities/js/helper';
import { loadLazyImages } from './utilities/js/lazy-image-loader';
import { EventScroller } from './utilities/js/event-scroller';
import { MediaMatchHandler } from './utilities/js/media-match-handler';
import { ResizeHandler } from './utilities/js/resize-handler';
import Siteheader from './layout/siteheader/siteheader';
import { getLocationHash, executeLocationHash } from './utilities/js/location-hash-jumper';

// GLOBAL OPTIONS
window.OPTIONS = {
    breakpoints: {
        s: 320,
        m: 768,
        l: 1024,
        xl: 1280,
        xxl: 1440,
        xxxl: 1920
    },
    loader: '<b class="loading"><b class="loading__loader"><i>loading...</i></b></b>'
};

window.eventScroller = new EventScroller();
window.mediaMatchHandler = new MediaMatchHandler();
window.resizeHandler = new ResizeHandler();

window.youtubeApi = false;
window.youtubeApiLoading = false;
window.bingMapsAPI = false;
window.siteheaderAPI = null;

const browserCheck = () => {
    window.browser = {
        csshover: !window.matchMedia('(pointer:coarse)').matches,
        ios: (/iPhone|iPad|iPod/i).test(navigator.userAgent),
        iphone: (/iPhone|iPod/i).test(navigator.userAgent),
        android: (/(android)/i).test(navigator.userAgent),
        firefox: (/firefox/i).test(navigator.userAgent),
        safari: (/Version\/[\d.]+.*Safari/).test(navigator.userAgent)
    };

    Object.entries(window.browser).forEach(([key, value]) => {
        document.documentElement.classList.add((!value) ? `no-${key}` : `${key}`);
    });
    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');
};

window.checkInView = (entries, observer) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            if (!entry.target.classList.contains('inview')) {
                entry.target.classList.add('inview');

                if (typeof entry.target.dataset.footer === 'undefined') {
                    window.inViewObserver.unobserve(entry.target);
                }

                if (typeof entry.target.dataset.map !== 'undefined' || typeof entry.target.dataset.studioDirections !== 'undefined') {
                    if (!window.googleApiReady) {
                        loadGoogleApi();
                    }
                }
            }
        }
    });
};

window.inViewObserver = new IntersectionObserver(window.checkInView, {
    rootMargin: '-15%'
});

const initContent = ($content) => {
    console.log('start app');
    loadLazyImages();

    // youtube related calls
    const $youtubeVideos = $content.querySelectorAll('[data-youtube]');
    if ($youtubeVideos.length > 0) {
        import('./utilities/js/youtube-api-loader').then(({ loadYoutubeApi }) => {
            loadYoutubeApi();
        });

        window.onYouTubeIframeAPIReady = () => {
            import('./utilities/js/youtube-player').then(({ YoutubePlayer }) => {
                const youtubePlayer = new YoutubePlayer($youtubeVideos);
                youtubePlayer.initialize();
            });
        };
    }
};

domready(function () {
    const initApplication = () => {
        browserCheck();
        executeLocationHash();
        getLocationHash();

        window.eventScroller.init();
        window.resizeHandler.init();

        window.dataInview = document.querySelectorAll('[data-inview]:not(.inview)');
        setTimeout(() => {
            window.dataInview.forEach((dataInView) => {
                window.inViewObserver.observe(dataInView);
            });
        }, 500);

        const $siteheader = document.querySelector('[data-language="root"]');
        if ($siteheader) {
            const siteheaderAPI = new Siteheader($siteheader);
            siteheaderAPI.initialize();
            window.siteheaderAPI = siteheaderAPI;
        }

        const contentUpdateEvent = new CustomEvent('content.loaded', {
            view: window,
            bubbles: true,
            cancelable: false,
            detail: {
                $context: document
            }
        });

        window.dispatchEvent(contentUpdateEvent);

        document.body.classList.add('page--loaded');
        window.addEventListener('beforeunload', () => {
            const isMailTo = document.activeElement.protocol === 'mailto:';
            const isTel = document.activeElement.protocol === 'tel:';

            if (!(isMailTo && isTel)) {
                document.body.classList.remove('page--loaded');
            }
        });

        window.addEventListener('pageshow', (event) => {
            const historyTraversal = event.persisted || (typeof window.performance !== 'undefined' && window.performance.navigation.type === 2);
            if (historyTraversal) {
                window.location.reload();
            }
        });

        initContent(document);
    };

    initApplication();
});
